namespace Nobox {
    export interface ChatroomsFilterForm {
        St: StatusInboxEditor;
        Channel: Serenity.ServiceLookupEditor;
        Chat: TypeChatConversation;
        Account: Serenity.ServiceLookupEditor;
        Contact: Serenity.ServiceLookupEditor;
        Link: Serenity.ServiceLookupEditor;
        Group: Serenity.ServiceLookupEditor;
        Campaign: Serenity.ServiceLookupEditor;
        Funnel: Serenity.ServiceLookupEditor;
        Deal: Serenity.ServiceLookupEditor;
        Tags: Serenity.ServiceLookupEditor;
        Agent: Serenity.ServiceLookupEditor;
    }

    export class ChatroomsFilterForm extends Serenity.PrefixedContext {
        static formKey = 'Chat.ChatFilterrooms';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChatroomsFilterForm.init)  {
                ChatroomsFilterForm.init = true;

                var s = Serenity;
                var w0 = StatusInboxEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = TypeChatConversation;

                Q.initFormType(ChatroomsFilterForm, [
                    'St', w0,
                    'Channel', w1,
                    'Chat', w2,
                    'Account', w1,
                    'Contact', w1,
                    'Link', w1,
                    'Group', w1,
                    'Campaign', w1,
                    'Funnel', w1,
                    'Deal', w1,
                    'Tags', w1,
                    'Agent', w1
                ]);
            }
        }
    }
}
